module.exports = __webpack_public_path__ + "img/aep.001fe8d1.svg";